import Inbox from "../pages/messaging/message/inbox";
import Outbox from "../pages/messaging/message/outbox";
import Send from "../pages/messaging/message/send";
import View from "../pages/messaging/message/view";

import PasswordChange from "../pages/messaging/passwordChange/passeordChange";

export const messageRoutes = [
  {
    path: `/messaging/inbox`,
    Component: <Inbox />,
    permission: "message.inbox"
  },
  {
    path: `/messaging/outbox`,
    Component: <Outbox />,
    permission: "message.outbox"
  },
  {
    path: `/messaging/send`,
    Component: <Send />,
    permission: "message.send"
  },
  {
    path: `/messaging/view/:id`,
    Component: <View />,
    permission: "message.view"
  },

  {
    path: `/messaging/password-change`,
    Component: <PasswordChange />,
    permission: "passwordchange"
  }
];
